"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobDuty = void 0;
var utils_1 = require("../../utils");
var jobDutiesUrl = '/job-duties';
var jobDutyNoUrl = '/{jobDutyNo}';
// [Job Duty]
exports.jobDuty = function (axios) {
    return {
        getJobDuties: function () {
            return axios.get(jobDutiesUrl);
        },
        postJobDuties: function (postJobDutyRequest) {
            return axios.post(jobDutiesUrl, postJobDutyRequest.data);
        },
        putJobDuties: function (putJobDutyRequest) {
            var url = "" + jobDutiesUrl + jobDutyNoUrl;
            url = utils_1.paramPathchange(url, putJobDutyRequest);
            return axios.put(url, putJobDutyRequest.data);
        },
        deleteJobDuties: function (deleteJobDutyRequest) {
            var url = "" + jobDutiesUrl + jobDutyNoUrl;
            url = utils_1.paramPathchange(url, deleteJobDutyRequest);
            return axios.delete(url);
        },
        putJobDutiesDisplayOrder: function (putJobDutyDisplayOrderRequest) {
            var url = "" + jobDutiesUrl + jobDutyNoUrl + "/display-order";
            url = utils_1.paramPathchange(url, putJobDutyDisplayOrderRequest);
            return axios.put(url, putJobDutyDisplayOrderRequest.data);
        }
    };
};
